export default __webpack_public_path__ + "static/dapp-1-9d78ea23643986987f717484ec078177.jpeg";